<div
  class="flex justify-between border-text-extra-light bg-background-white"
  [ngClass]="isNewModalDesign() ? 'items-start' : 'mt-8 h-[54px] items-center'"
  [class.justify-between]="hasBackButton"
  [class.justify-end]="!hasBackButton"
>
  @if (hasBackButton) {
    <div class="flex cursor-pointer items-center text-primary-blue" (click)="back()">
      <svg-icon key="px-16-arrow-left" size="sm"></svg-icon>
      <span class="ml-3 font-medium">Back</span>
    </div>
  }

  @if (isNewModalDesign()) {
    <div
      class="typo-h8-semibold rounded-3xl border-2 border-solid border-primary-blue px-3 font-poppins uppercase leading-6 tracking-[0.5px] text-[#595959]"
    >
      {{ badgeTranslationKey() | translate }}
    </div>
  }

  @if (loggedInUser && hasUserProfile()) {
    <button [cdkMenuTriggerFor]="menu" class="flex items-center" [ngClass]="isNewModalDesign() ? 'gap-1' : 'gap-3'">
      <span class="typo-h5-semibold text-text-primary">{{ loggedInUser.firstName }} {{ loggedInUser.lastName }}</span>
      <lib-avatars [size]="isNewModalDesign() ? 32 : 44" [persons]="[loggedInUser]"></lib-avatars>
    </button>

    <ng-template #menu>
      <div
        cdkMenu
        class="bg-blur-shadow-card relative top-[15px] flex flex-col gap-4 rounded-3xl border-2 border-states-white bg-states-white p-4"
      >
        <a
          class="typo-h4-thin flex flex-row items-center gap-2 text-text-primary hover:font-semibold"
          cdkMenuItem
          routerLinkActive
          #rla="routerLinkActive"
          [class.bg-background-light-blue]="rla.isActive"
          [routerLink]="['/']"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img class="h-[24px] w-[24px] items-center" src="assets/images/logo-beta-header.svg" height="24" width="24" />
          <span class="pt-1 align-middle">{{ 'site_setup_back_to_ffd' | translate }}</span>
        </a>
        <button
          class="typo-h4-medium flex flex-row items-center gap-2 text-states-red hover:font-semibold hover:text-states-deep-red"
          cdkMenuItem
          (click)="onLogOutClick()"
        >
          <svg-icon key="px-24-logout"></svg-icon>
          <span>{{ 'common_header_log_out' | translate }}</span>
        </button>
      </div>
    </ng-template>
  }
</div>
